const SkillProfilesTab = () => {
  return <div>Skill profiles tab</div>;
};

export default SkillProfilesTab;
